type AccessIssue = any;
export type { AccessIssue as default };

export const AccessIssues: AccessIssue[] = [
    0,
    1,
];
